export const SERIAL_SPACING = 1;

export function getDColsNum(d) {
  if (typeof d === "object" && d) {
    if (d.connId) {
      return d.allColsNum;
    }
    else if (d.direction === "horizontal") {
      return d.devices.length;
    }
    else {
      return 1;
    }
  }
  else {
    return 0;
  }
}

export function getDRowsNum(d) {
  if (typeof d === "object" && d) {
    if (d.connId) {
      return d.allRowsNum;
    }
    else if (d.direction === "vertical") {
      return d.devices.length;
    }
    else {
      return 1;
    }
  }
  else {
    return 0;
  }
}